@if (!isImpersonationErrorRoute()) {
    <nm-imp-banner />
}

<router-outlet></router-outlet>
<cve-ui-loader></cve-ui-loader>
<cve-ui-toast [breakpoint]="breakpoint"></cve-ui-toast>
